export default {
  List: 'list',
  Mosaic: 'mosaic',
  Grid: 'grid',
}
